export default __webpack_public_path__ + "static/media/ic_news_on.edd7989a.svg";